import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";
import * as env from "shared/env";

export const styles = (theme: Theme) => {
	return ({
		container: {
			marginRight: 14
		},
		bookmark: {
			color: theme.palette.primary.main
		},
		activeBookmark: {
			color: theme.palette.primary.main,
			fill: "currentColor",
		},
		label: {
			color: theme.palette.primary.main,
			fontSize: 14,
			marginLeft: 4,
			textTransform: "none",
		},
	} satisfies Record<string, CSSObject>);
};
